import { render, staticRenderFns } from "./MovimientosList.vue?vue&type=template&id=040436bc&"
import script from "./MovimientosList.vue?vue&type=script&lang=js&"
export * from "./MovimientosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports